<template>
  <div>
<!-- <el-table
    :data="tableData"
    style="width: 100%"
    row-key="dtId"
    border
    lazy
    :load="load"
    :tree-props="{children: 'children', hasChildren: 'hasChildren'}">

    <el-table-column
      prop="dtName"
      label="战队"
      width="180">
    </el-table-column>

    <el-table-column
      prop="dtYj"
      label="业绩"
      width="180">
    </el-table-column>

    <el-table-column
      prop="dtOrderNum"
      label="订单数">
    </el-table-column>

    <el-table-column
      prop="dtBusinessNum"
      label="数量">
    </el-table-column>

    <el-table-column
      prop="dtPoints"
      label="积分">
    </el-table-column>

    <el-table-column
      prop="dtVisitorNum"
      label="拜访量">
    </el-table-column>
  </el-table>
 -->

 <mytable ref="mytable"
   :tree="{children: 'children', lazy: lazyLoad}"
   :tableColums='tableColums_getUserTargetList'
   api='getProjectAnalysis::dtId'
   xupdateapi='updateUserTarget'
   :height="H-165"
   @expand="expand" >
     <!-- <div slot="utTargetJs" slot-scope='{row}' >{{ row.utTargetJs || 0 }}</div>
     <div slot="utTargetJe" slot-scope='{row}' >{{ row.utTargetJe || 0 }}</div>
     <div slot="utTargetSl" slot-scope='{row}' >{{ row.utTargetSl || 0 }}</div> -->

 </mytable>
  </div>

</template>

<script>
  export default {
    data(){
      return {
        tableData:[
        //   {
        //   dtId:null,
        //   dtName:'',
        //   dtyj:'',
        //   dtOrderNum:'',
        //   dtBusinessNum:'',
        //   dtPoints:'',
        //   dtVisitorNum:''
        // },
        ],
        tableColums_getUserTargetList: {
          $selection: false,

          dtName: ['战队|align:left',400],

           dtYj: '业绩', // (点击编辑)
          dtOrderNum: '订单数', // (点击编辑)
          dtBusinessNum: '数量', // (点击编辑)

          dtPoints: '积分',
         dtVisitorNum: '拜访量',

        },
      }
    },
    methods:{
     project(){
        this.getProjectAnalysis().result(res =>{
          this.tableData=res.data.data
            this.tableData.forEach((item,value)=>{
              console.log(item)
              if(item.dtId != null){
                this.getProjectAnalysis({
                  dtId:item.dtId
                }).result(res =>{
                  item.children=res.data.data
                  console.log(item.children)
                   // child(item.children)
                   // function child(item){
                   //  for(var e =0;e<item.length;e++){
                   //    const dt = item[e]
                   //    console.log(dt)
                   //    if(dt.dtId !=null){
                   //      this.getProjectAnalysis({
                   //        dtId:dt.dtId
                   //      }).result(res =>{
                   //        dt.children = res.data.data
                   //        child(dt.children)
                   //      })
                   //    }
                   //  }
                   // }

                })
              }
            })
        })


      }
,
      expand(row, expanded) {
          // // if( row.dtLevel == 1 || row.hasChildren2 === false ) return;
          // const treeData = this.$refs.mytable.Table.store.states.treeData, children = ( treeData[ row._parent ] || 0 ).children || '';
          // if( children.length < 2 ) return;
          // // console.error(row, expanded, row._parent, children, row.hasChildren);
          // for( let id of children ) {
          //     if( id !== row.dtId ) treeData[id] && ( treeData[id].expanded = false );
          // };
          // return;
          console.log(row)
          console.log(expanded)
      },
      lazyLoad(treeData, treeNode, resolve) {
         console.log(treeData,treeNode,resolve)
          if(treeData.dtId !== null){
            this.getProjectAnalysis({
              dtId:treeData.dtId
            }).result(res =>{
              
            })
          }
          // console.error(res.data.data, resolve, treeNode);
      },
    },
    created() {
     // this.project()
     this.getProjectAnalysis()
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/discoveries/ProjectAnalysis.vue